import { contactInfo } from "@/mocks/homeData";

export default function HeroSection() {
  const handleScrollTo = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="accueil"
      className="relative min-h-[100dvh] flex items-start md:items-center justify-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <picture className="block w-full h-full">
          <source
            media="(max-width: 767px)"
            srcSet="/assets/images/hero-mobile.jpg"
          />
          <img
            alt="Atelier mécanique Mobicar Pro"
            className="w-full h-full object-cover"
            loading="eager"
            fetchPriority="high"
            width="1600"
            height="900"
            src="/assets/images/hero.jpg"
          />
        </picture>
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-black/80" />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 md:px-6 text-center pt-28 pb-20 md:pt-20 md:pb-0">
        <span className="inline-block px-4 py-1.5 mb-6 text-sm font-medium tracking-wider text-primary-400 bg-primary-950/30 border-2 border-primary-500/70 rounded-full uppercase">
          Garage automobile au Tampon
        </span>

        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6 font-heading tracking-wide">
          Entretien, diagnostic et réparation automobile
        </h1>

        <p className="text-base md:text-lg text-white/90 max-w-2xl mx-auto mb-10 leading-relaxed">
          Mobicar Pro vous accompagne pour le diagnostic automobile, l'entretien
          et la réparation de votre véhicule au Tampon. Une prise en charge
          sérieuse, des explications claires et un devis adapté à
          l'intervention nécessaire.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4 mb-12">
          <a
            href={contactInfo.phoneHref}
            className="inline-flex items-center gap-2 px-7 py-3.5 bg-primary-500 hover:bg-primary-600 text-white font-semibold rounded-md transition-colors whitespace-nowrap w-full sm:w-auto justify-center"
          >
            <i className="ri-phone-line w-5 h-5 flex items-center justify-center" />
            Appeler le garage
          </a>
          <a
            href={contactInfo.whatsappDevisHref}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-7 py-3.5 bg-white/10 hover:bg-white/20 text-white font-semibold rounded-md border border-white/30 transition-colors whitespace-nowrap w-full sm:w-auto justify-center"
          >
            <i className="ri-whatsapp-line w-5 h-5 flex items-center justify-center" />
            Demander un devis
          </a>
          <button
            type="button"
            onClick={() => handleScrollTo("#prestations")}
            className="inline-flex items-center gap-2 px-7 py-3.5 bg-transparent hover:bg-white/10 text-white font-semibold rounded-md border border-white/20 transition-colors whitespace-nowrap w-full sm:w-auto justify-center cursor-pointer"
          >
            Découvrir les prestations
          </button>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4 max-w-2xl mx-auto">
          {[
            "Diagnostic et recherche de panne",
            "Entretien et réparation",
          ].map((tag) => (
            <div
              key={tag}
              className="flex items-center gap-2 px-3 py-2.5 bg-white/10 backdrop-blur-sm rounded-md border border-white/10"
            >
              <i className="ri-check-line text-primary-400 w-4 h-4 flex items-center justify-center shrink-0" />
              <span className="text-xs md:text-sm text-white/90 text-left leading-tight">
                {tag}
              </span>
            </div>
          ))}
        </div>
      </div>

      <button
        type="button"
        onClick={() => handleScrollTo("#prestations")}
        className="absolute bottom-3 left-1/2 -translate-x-1/2 text-white/60 hover:text-white transition-colors cursor-pointer z-10"
        aria-label="Défiler vers le bas"
      >
        <i className="ri-arrow-down-double-line w-8 h-8 flex items-center justify-center text-2xl" />
      </button>
    </section>
  );
}